// extracted by mini-css-extract-plugin
export default {"overlay-not-provisioned":"src-common-OverlayNotProvisioned-style__overlay-not-provisioned--tsa5r"};